import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  resetError: () => void;
}

export const ErrorFallback: React.FC<Props> = ({ resetError }) => {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-4 text-foreground">
      <h1 className="text-title-36">{t('global.errorOccurred')}</h1>
      <p>{t('global.unknownError')}</p>
      <button
        type="button"
        onClick={resetError}
        className="cursor-pointer underline"
      >
        {t('global.tryAgain')}
      </button>
    </div>
  );
};
